import React from 'react';
import './FinancialRatioStatus.css';

export function FinancialRatiosExplanation() {
  return (
    <p className="financial-ratios-explanation">
      Latest available annual fiscal-period ratios. Valuations use the fiscal-period-end price;
      values are not live or TTM. NA means data is unavailable. Stocks with missing values
      do not match an active filter for that metric.
    </p>
  );
}

export default function FinancialRatioStatus({ result }) {
  if (!result || result.status === 'loading') {
    return <span className="financial-ratio-status">Loading annual data…</span>;
  }
  if (result.status === 'error') {
    return <span className="financial-ratio-status">Could not load data. Reload to retry.</span>;
  }
  if (result.status === 'unavailable') {
    return <span className="financial-ratio-status">Annual data unavailable</span>;
  }
  const { data } = result;
  return (
    <span className="financial-ratio-status" title={`Annual period ended ${data.date}${data.filingDate ? `; filed ${data.filingDate}` : ''}`}>
      {data.fiscalYear ? `FY ${data.fiscalYear}` : 'FY'}
      <span aria-label={`Period ended ${data.date}`}>{data.date}</span>
    </span>
  );
}

export function FinancialRatioValue({ result, metric }) {
  if (!result || result.status === 'loading') {
    return <span className="loading-placeholder">Loading...</span>;
  }
  const value = result.data?.[metric];
  return Number.isFinite(value) ? value.toFixed(2) : 'NA';
}
